<template>
    <div class="suggestions-bar">
        <span class="suggestions-bar-title">{{ getString('combina_com_seu_pedido') }}</span>
        <div class="suggestions-bar-products">

            <div class="prod_item" v-for="(prod, key) in currentGroup.products" :key="key"
                @click="suggestChoose(prod, currentGroup.groupCode)">
                <div class="img_container">
                    <img v-if="prod.productImages && prod.productImages.small"
                        :src="getImagesURL(prod, 'productImages', 'small')" alt="">
                    <img v-else :src="noImageSrc">
                </div>
                <div class="name_container">
                    <span class="name" v-text="getProductLanguage(prod, 'productName')"></span>
                </div>
                <div class="price_container">
                    <span class="price" v-text="getMinPrice(prod)"></span>
                </div>
                <button class="btn-adicionar" @click.stop="suggestChoose(prod, currentGroup.groupCode)">
                    {{getString('adicionar')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import MinPriceController from '@/assets/controllers/MinPriceController'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import DefaultButton from '@/components/DefaultButton'

export default {
    name: 'SuggestionsBar',
    components: {
        DefaultButton
    },
    props: ['productCode', 'groupCode', 'indexCart'],
    data () {
        return {
            noImageSrc: null,
            junk: '/static/icons/junk-icon.png',
            suggestions: [],
            groupIndex: 0
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        setTimeout(() => { this.getSuggestions() }, 500)
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        exibApartir: function (suggest) {
            return Util.exibApartir() && Util.variablePrice(suggest)
        },
        getMinPrice: function (suggest) {
            return MinPriceController.getMinPrice(suggest)
        },
        getGroupMinPrice: function (group) {
            if (!group.products || group.products.length === 0) return ''
            const prices = group.products.map(p => p.fullPrice).filter(price => price > 0)
            if (prices.length === 0) return ''
            return Util.formatMoney(Math.min(...prices))
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getSuggestions: async function () {
            this.suggestions = await SuggestionsController.getSuggestions(
                this.groupCode, this.productCode, this.indexCart
            )
            const savedIndex = SuggestionsController.getCurrentGroupIndex()
            if (savedIndex >= this.suggestions.length) {
                this.$emit('closeSuggestions')
                return
            }
            this.groupIndex = savedIndex
        },
        suggestChoose: function (prod, groupCode) {
            prod.productSuggested = true
            prod.categoryGroupCode = groupCode
            SuggestionsController.setProductGroupSuggested(groupCode)
            this.$emit('handleSuggestion', prod)
            if (!this.isLastGroup()) {
                this.groupIndex++
                return
            }
            this.$emit('closeSuggestions')
        },
        chooseGroup: function (group) {
            this.suggestions
                .filter(s => s.isGroupSuggestion)
                .forEach(s => SuggestionsController.setProductGroupSuggested(s.groupCode))
            this.$emit('navigateToGroup', group.groupName)
            this.$emit('closeSuggestions')
        },
        noMoreSuggestions: function () {
            SuggestionsController.setIgnoreAllSuggestions(true)
            this.$emit('closeSuggestions')
        },
        isLastGroup: function () {
            return this.groupIndex === (this.suggestions.length - 1)
        }
    },
    computed: {
        currentGroup () {
            const group = this.suggestions[this.groupIndex] || {}
            return { ...group, products: group.products || [] }
        },
        currentProduct () {
            return this.currentGroup.products[this.productIndex] || null
        },
        visibleProducts () {
            return this.currentGroup.products.slice(this.productIndex, this.productIndex + 3)
        }
    },
    watch: {
        productCode (newVal) {
            if (newVal) {
                this.getSuggestions()
            }
        },
        groupIndex () {
            this.productIndex = 0
        }
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.suggestions-bar {
    position: relative;
    left: 0;
    right: 0;
    z-index: 2;
    display: grid;
    align-items: center;
    background: @white;
    padding: 10px 20px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    .button-default[data-v-6f66515a] {
            min-width: 190px;
    }

    .suggestions-bar-title {
        display: block;
        font-size: 1.9rem;
        font-weight: bold;
        color: @primary-color;
        margin-bottom: 10px;
    }

    .suggestions-bar-products {
        display: flex;
        flex-direction: row;
        gap: 30px;
        overflow-x: scroll;

        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
        min-width: 0;
        max-width: 100%;
        padding-bottom: 5px;

        .prod_item {
            scroll-snap-align: start;
            flex-shrink: 0;
            display: grid;
            grid-template-rows: 150px 60px 40px 35px;
            width: 200px;
            cursor: pointer;
            text-align: center;
            border-radius: 10px;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
            padding: 5px;

            .img_container img {
                object-fit: contain;
                width: 100%;
                max-height: 150px;
            }

            .name_container .name {
                font-size: 1.5rem;

                display: block;
            }

            .price_container {
                .from { font-size: 0.7rem; color: @primary-dark; display: block; }
                .price { font-size: 1.5rem; color: var(--price-font-color); }
            }

            .btn-adicionar {
                background-color: @primary-color;
                color: @white;
                border: none;
                border-radius: 5px;
                font-size: 0.75rem;
                font-weight: bold;
                cursor: pointer;
                width: 100%;
                padding: 5px 0;
            }
        }
    }

    .suggestions-bar-products::-webkit-scrollbar {
        height: 8px;
    }
    .suggestions-bar-footer {
        display: flex;
        justify-content: flex-end;
    }
}

@media (max-width: 698px) {
    .suggestions-bar {
        padding: 5px 10px;
        border-radius: 6px;

        .suggestions-bar-title {
            font-size: 1rem;
            margin-bottom: 5px;
        }

        .suggestions-bar-products {
            gap: 10px;

            .prod_item {
                width: 100px;
                grid-template-rows: 50px 30px 20px 28px;

                .img_container img { max-height: 50px; }
                .name_container .name { font-size: 0.7rem; }
                .price_container .price { font-size: 0.8rem; }
                .btn-adicionar { font-size: 0.65rem; }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .suggestions-bar {
        padding: 8px 15px;

        .suggestions-bar-title {
            font-size: 1.2rem;
            margin-bottom: 8px;
        }

        .suggestions-bar-products {
            gap: 20px;

            .prod_item {
                width: 130px;
                grid-template-rows: 70px 35px 25px 32px;

                .img_container img { max-height: 70px; }
                .name_container .name { font-size: 0.8rem; }
                .price_container .price { font-size: 0.9rem; }
                .btn-adicionar { font-size: 0.65rem; }
            }
        }
    }
}

@media (orientation: landscape) {
    .suggestions-bar {
        padding: 5px 15px;

        .suggestions-bar-title {
            font-size: 1rem;
            margin-bottom: 4px;
        }

        .suggestions-bar-products {
            gap: 15px;

            .prod_item {
                width: 120px;
                grid-template-rows: 55px 30px 22px 28px;

                .img_container img { max-height: 55px; }
                .name_container .name { font-size: 0.75rem; }
                .price_container .price { font-size: 0.85rem; }
                .btn-adicionar { font-size: 0.65rem; }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SuggestionsComponents/SuggestionsBar.vue